import { User, Users, type LucideIcon } from 'lucide-react';
import { type CatchAllAssignee } from '@vagusx/clients';

/**
 * Icon for each catch-all assignee variant. Exhaustive on the
 * `CatchAllAssignee` union — adding a new entry to
 * `CATCH_ALL_ALLOWED_ASSIGNEES` (in @vagusx/clients) fails to compile
 * here until the icon mapping is added.
 *
 * Lives in web because clients is a server-shared contract package
 * and cannot import lucide-react.
 */
export const CATCH_ALL_ICONS: Record<CatchAllAssignee, LucideIcon> = {
  user: User,
  team: Users,
};
